function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import events from './events';
var prefix = 'debounced';
var initializedEvents = {};
export var debounce = function debounce(fn) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var wait = options.wait;
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, wait);
  };
};
var dispatch = function dispatch(event) {
  var bubbles = event.bubbles,
    cancelable = event.cancelable,
    composed = event.composed;
  var debouncedEvent = new CustomEvent("".concat(prefix, ":").concat(event.type), {
    bubbles: bubbles,
    cancelable: cancelable,
    composed: composed,
    detail: {
      originalEvent: event
    }
  });
  setTimeout(event.target.dispatchEvent(debouncedEvent));
};
export var initializeEvent = function initializeEvent(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (initializedEvents[name]) return;
  initializedEvents[name] = options || {};
  var debouncedDispatch = debounce(dispatch, options);
  document.addEventListener(name, function (event) {
    return debouncedDispatch(event);
  });
};
var initialize = function initialize() {
  var evts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : events;
  prefix = evts.prefix || prefix;
  delete evts.prefix;
  for (var _i2 = 0, _Object$entries = Object.entries(evts); _i2 < _Object$entries.length; _i2++) {
    var _ref = _Object$entries[_i2];
    var _ref2 = _slicedToArray(_ref, 2);
    var name = _ref2[0];
    var options = _ref2[1];
    initializeEvent(name, options);
  }
};
export default {
  debounce: debounce,
  events: events,
  initialize: initialize,
  initializeEvent: initializeEvent,
  initializedEvents: initializedEvents
};